module.exports = __webpack_public_path__ + "img/didtelekom-logo.555c6d44.svg";